/**
 * @generated SignedSource<<732d9c190745caffddb4544a97cb6362>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TestEventType = "FORGOT" | "REMEMBERED" | "REVIEWED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserSongsList_user$data = {
  readonly boxIntervals: ReadonlyArray<number>;
  readonly email: string;
  readonly emailConfirmed: boolean;
  readonly id: string;
  readonly testHistory: ReadonlyArray<{
    readonly eventType: TestEventType;
    readonly song: string;
    readonly time: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"SongManageShare_user">;
  readonly " $fragmentType": "UserSongsList_user";
};
export type UserSongsList_user$key = {
  readonly " $data"?: UserSongsList_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSongsList_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserSongsList_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "boxIntervals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailConfirmed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTestEvent",
      "kind": "LinkedField",
      "name": "testHistory",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "song",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SongManageShare_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "82fabfbfa175b910921d702c43150e5b";

export default node;
